const WORDS = ["Google Ads", "Meta Ads", "Search Engine Optimisation", "Google Business Profile", "GA4 & Tag Manager", "Conversion Rate Optimisation", "Websites that convert", "Plain-English reporting"];

export const Marquee = () => (
  <div className="marquee relative overflow-hidden border-y border-violet-200 bg-[#F5F0FF] py-8" data-testid="editorial-marquee" aria-label="Capabilities">
    <div className="marquee-track flex items-center gap-10">
      {[...WORDS, ...WORDS].map((w, i) => (
        <span key={i} className="flex items-center gap-10 whitespace-nowrap" aria-hidden={i >= WORDS.length}>
          <span className={`text-4xl sm:text-6xl ${i % 2 ? "serif-accent text-[#581C87]" : "font-extrabold text-outline"}`}>{w}</span>
          <span className="h-3 w-3 rotate-45 bg-[#2563EB]" />
        </span>
      ))}
    </div>
  </div>
);
